export function percentile(values: number[], p: number): number {
  if (!values.length) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  return sorted[Math.min(sorted.length - 1, Math.floor((sorted.length - 1) * p))];
}
export class Metrics {
  frames: number[] = [];
  physics: number[] = [];
  structure: number[] = [];
  render: number[] = [];
  logic: number[] = [];
  gpu: number[] = [];
  sequence = 0;
  timings: {
    sequence: number;
    frameMs: number;
    physicsMs: number;
    structureMs: number;
    renderMs: number;
    logicMs: number;
    gpuMs?: number;
  }[] = [];
  maxFrames = 1200;
  sample(ms: number, physics: number, structure: number, render = 0, logic = 0, gpu?: number): void {
    this.frames.push(ms);
    this.physics.push(physics);
    this.structure.push(structure);
    this.render.push(render);
    this.logic.push(logic);
    if (gpu !== undefined) {
      this.gpu.push(gpu);
      if (this.gpu.length > this.maxFrames) this.gpu.shift();
    }
    this.timings.push({
      sequence: ++this.sequence,
      frameMs: ms,
      physicsMs: physics,
      structureMs: structure,
      renderMs: render,
      logicMs: logic,
      gpuMs: gpu,
    });
    if (this.frames.length > this.maxFrames) {
      this.frames.shift();
      this.physics.shift();
      this.structure.shift();
      this.render.shift();
      this.logic.shift();
      this.timings.shift();
    }
  }
  reset(): void {
    this.frames = [];
    this.physics = [];
    this.structure = [];
    this.render = [];
    this.logic = [];
    this.gpu = [];
    this.timings = [];
  }
  summary(): Record<string, number> {
    const f = this.frames;
    let recentMs = 0,
      recentFrames = 0;
    for (let i = f.length - 1; i >= 0 && recentMs < 1000 - 1e-6; i--) {
      recentMs += f[i];
      recentFrames++;
    }
    return {
      samples: f.length,
      fps: recentMs ? (1000 * recentFrames) / recentMs : 0,
      fpsWindowMs: recentMs,
      frameP50: percentile(f, 0.5),
      frameP95: percentile(f, 0.95),
      frameP99: percentile(f, 0.99),
      physicsP95: percentile(this.physics, 0.95),
      structureP95: percentile(this.structure, 0.95),
      renderP95: percentile(this.render, 0.95),
      logicP95: percentile(this.logic, 0.95),
      gpuSamples: this.gpu.length,
      gpuP95: percentile(this.gpu, 0.95),
    };
  }
}
